export enum WorkerTypeCodeEnum {
  INTERMITTENT = 'INTERMITTENT',
  STRINGER = 'STRINGER',
  PERMANENT = 'PERMANENT',
  AUTHOR = 'AUTHOR',
  EXTRA = 'EXTRA',
  OTHER = 'OTHER',
}
